import { useIntl } from "react-intl";

import {
  DrawerContent,
  DrawerTopBar,
  DrawerTopBarActionButton,
  SwipeableDrawer,
} from "@/components/Drawer";
import type { StopsOptions } from "@/features/flights/types/types";

import { StopsFilter } from "./flight-filters/StopsFilter";

type Props = {
  open: boolean;
  defaultValue?: StopsOptions;
  value?: StopsOptions;
  onSubmit: (newValue?: StopsOptions) => void;
  onClose: () => void;
};

export const StopsFilterDrawer = ({
  open,
  defaultValue,
  value,
  onSubmit,
  onClose,
}: Props) => {
  const intl = useIntl();

  return (
    <SwipeableDrawer open={open} onClose={onClose}>
      <DrawerTopBar
        onCloseClick={onClose}
        title={intl.formatMessage({
          defaultMessage: "Stops",
          description: "Filter label for the stops / layovers filter",
        })}
        actionElement={
          <DrawerTopBarActionButton
            onClick={() => {
              onSubmit(defaultValue);
            }}
          >
            {intl.formatMessage({
              defaultMessage: "Clear filter",
              description: "Button to remove a single active filter",
            })}
          </DrawerTopBarActionButton>
        }
      />

      <DrawerContent>
        <StopsFilter value={value} onChange={onSubmit} />
      </DrawerContent>
    </SwipeableDrawer>
  );
};
